
import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";

interface PhotoModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  photoUrl: string;
  description: string;
}

export const PhotoModal = ({ isOpen, onClose, title, photoUrl, description }: PhotoModalProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[90vw] max-h-[90vh]">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>
            {description}
          </DialogDescription>
        </DialogHeader>
        <div className="w-full flex justify-center">
          <img 
            src={photoUrl} 
            alt={title} 
            className="max-w-full max-h-[70vh] object-contain rounded-lg" 
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};
